// extracted by mini-css-extract-plugin
export default {"main":"TstorySkin_main__78hAJ"};